<template>
  <div id="ShowPerferaj">
    <div class="row">
      <div class="col-md-3 col-12">
        <small id="LblGhest">نام پرفراژ :</small>
        <!-- انتخاب نوع پرفراژ -->
        <!-- <combo
          :ActionUrl="'b_GetPerferajFormatDataView'"
          :IsDisabled="false"
          :IsLoad="true"
          :Params="this.b_NoePerf"
          @ValueResult="ValueResultGetPerferaj"
          :Op_TextDefult="'انتخاب پرفراژ'"
          :IsDefault="true"
          :FKId="this.tblTaahodatId"
          tabindex="1"
        ></combo> -->
        <SearchableCombo
              :edit="false"
              :grp="0"
              :code="null"
              @ResultCombo="ValueResultGetPerferaj"
              :rownumintable="3"
              :action="'TblCombo/b_GetPerferajFormatDataView'"
              :method="'Get'"
              :idinput="'GetPerferajFormatDataView'"
              :keyItem="'GetPerferajFormatDataView'"
               :queryString="{ id: b_NoePerf ,ShobeId:1,FKId:tblTaahodatId }" 

            >
            </SearchableCombo>
        <hr />
        <small id="lblChandGane">پیش نمایش</small>
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input InputText"
            id="chkIsPreview"
            tabindex="8"
            v-model="IschkIsPreview"
          />
          <label class="custom-control-label" for="chkIsPreview"></label>
        </div>
      </div>
      <div class="col-md-9 col-12">
        <!-- اطلاعات جدولی که در پرفراژ نمایش داده میشود -->
        <BnpGrid
          :propsRows="rows"
          :propsColumn="columns"
          :action="true" :hasRowNum="true" :Sortable="true"
        >

          <template slot="IsPrinted" slot-scope="props" class="text-center">
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input InputText"
                :checked="props.cell_value"
                id="IsPrinted"
                disabled
              />
              <label class="custom-control-label" for="IsPrinted"></label>
            </div>
          </template>
          <template slot="NeedPrint" slot-scope="props" class="text-center">
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input InputText"
                :checked="props.cell_value"
                id="NeedPrint"
                v-model="IsNeedPrint"
              />
              <label class="custom-control-label" for="NeedPrint"></label>
            </div>
          </template>
        </BnpGrid>
        <!-- کامپوننت پرفراژ صدا زده میشود
          MRTTostr    متن فایل فرمت که از دیتا بیس خوانده شده است توسط کمبو
          dataPerferaj    اطلاعات نمایش در پرفراژ که از ای پی آ خوانده شده اند 
          IsPreview     مشخص میکند پرفراژ مستقیما چاپ شود یا پیش نمایش داشته باشد
         -->
        <perforage
          v-if="$store.state.renderComponent"
          :MrtToStr="MRTTostr"
          :dataFromApi="dataPerferaj"
          :IsPreview="IsPreview"
        ></perforage>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-12">
        <hr />
        <button
          class="btn btn-outline-success m-2"
          type="button"
          tabindex="42"
          @click="PrintPrf()"
        >
          <i class="fa fa-print" aria-hidden="true"></i> {{ lblPrint }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Perforage from './Perforage.vue';
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'

export default {
  components: {
    BnpGrid,
    Perforage,
    SearchableCombo
  },
  computed: {
    IsNeedPrint: {
      get() {
        return this.NeedPrint;
      },
      set(val) {
        this.NeedPrint = val;
      },
    },
    IschkIsPreview: {
      get() {
        return this.IsPreview;
      },
      set(val) {
        this.IsPreview = val;
        if (this.IsPreview) {
          this.lblPrint = "پیش نمایش";
        } else {
          this.lblPrint = "چـاپ";
        }
      },
    },
  },
  data() {
    return {
      lblPrint: "پیش نمایش",
      dataPerferaj: null,
      MRTTostr: "",
      In_params: 0,
      NeedPrint: true,
      IsPreview: true,
      rows: [],
      columns: [
        {
          label: "Id",
          name: "Id",
          visibility: false,
        },
        {
          label: "ردیف",
          name: "RowNumber",
        },
        {
          label: "چاپ",
          name: "NeedPrint",
        },
        {
          label: "چاپ شده",
          name: "IsPrinted",
        },
        {
          label: "شماره سند",
          name: "ShomareSanad",
        },
        {
          label: "تاریخ سند",
          name: "TarixSanad",
        },
        {
          label: "بدهکار",
          name: "Bedeh",
        },
        {
          label: "بستانکار",
          name: "Bestan",
        },
        {
          label: "tblSarfaslId",
          name: "tblSarfaslId",
          visibility: false,
        },
        {
          label: "tblSarfaslTypeId",
          name: "tblSarfaslTypeId",
          visibility: false,
        },
        {
          label: "مشخصات",
          name: "SahebHesab",
        },
      ],

      DataAxios_DataForPerferaj: {
        ArryfildValue: {},
        Method: "Post",
        Action: "Perforage/b_GetDataForPerferaj",
        Token: this.$session.get("Token"),
      },
    };
  },
  mounted() {
    this.In_params = this.b_NoePerf;
    // console.log(this.tblTaahodatId);
  },
  methods: {

    // با انتخاب هر کدام از ردیف های کمبو وابسته به پرفراژ انتخاب شده به ای پی آی میرود و اطلاعات پرفراژ مورد نظر را برمیگرداند
    ValueResultGetPerferaj(value) {
      if (value.id != null) {
        // فرمت پرفراژ را از کمبو دریافت میکند و در متغیر ذخیره میکند برای ارسال به کامپوننت پرفراژ
        this.MRTTostr = value.id.MRTTostr;
        var list = [];

        // آید پرفراژ شماره تعهدات و شماره سند به ای پی آی ارسال میشوند تا اطلاعات با فرمت مورد نیاز برگردانده شوند
        this.DataAxios_DataForPerferaj.ArryfildValue.b_NoePerf = value.id.tblComboIdPerferajType304;
        this.DataAxios_DataForPerferaj.ArryfildValue.b_IsTajmie = false;
        this.DataAxios_DataForPerferaj.ArryfildValue.tblTaahodatId = this.tblTaahodatId;
        this.DataAxios_DataForPerferaj.ArryfildValue.tblSanadId = this.tblSanadId;
        this.$PostData(this.DataAxios_DataForPerferaj)
          .then((data) => {
            list = data;
            // دیتای نهایی به صورت پراپز به کامپوننت پرفراژ ارسال میشود
            this.dataPerferaj = data;
          })
          .finally(() => {
            this.rows = list;
            this.$store.state.renderComponent = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
            });
          });
      }
    },
    PrintPrf() {
      this.$store.state.renderComponent = false;
      this.$nextTick(() => {
        this.$store.state.renderComponent = true;
      });
    },

  },
  props: ["b_NoePerf", "tblTaahodatId", "tblSanadId"],
};
</script>
<style scoped></style>
